import filtype from './filtype'

const arsrapporter = {
    arsrapport: {
        aktivertITrine: true,
        tekniskNavn: 'arsrapport',
        visningsnavn: 'Årsrapport',
        filtyper: [filtype.pdf]
    },
    arsrapport_riksveg: {
        aktivertITrine: true,
        tekniskNavn: 'arsrapport_riksveg',
        visningsnavn: 'Årsrapport riksveg',
        filtyper: [filtype.pdf]
    },
    arsrapport_fylkesveg: {
        aktivertITrine: true,
        tekniskNavn: 'arsrapport_fylkesveg',
        visningsnavn: 'Årsrapport fylkesveg',
        filtyper: [filtype.pdf]
    },
    arsrapport_kommunal_veg: {
        aktivertITrine: true,
        tekniskNavn: 'arsrapport_kommunal_veg',
        visningsnavn: 'Årsrapport kommunal veg',
        filtyper: [filtype.pdf]
    },
    nokkeltall: {
        aktivertITrine: true,
        tekniskNavn: 'nokkeltall',
        visningsnavn: 'Nøkkeltall',
        filtyper: [filtype.pdf]
    }
}

export default arsrapporter
